module.exports = __webpack_public_path__ + "img/44.2d652af9.png";